var React = require('react');

var TravelMap = React.createClass({

  map: null,
  markers: [],
  mapPosition: {},
  mapInitialHeight: 0,
  
  getInitialState: function() {
    return {
      mapCanvasStyle: {
        height: 400
      },
      mapExpanded: this.props.mapExpanded,
      currentView: "map-top"
    };
  },
  
  isLatLng: function(obj){
    return !!obj && (!!obj.lat || !!obj.Lat) && (!!obj.lng || obj.Lng);
  },

  normalizeLatLng: function(obj){
    if (this.isLatLng(obj)){
      obj.lat = obj.lat || obj.Lat;
      obj.lng = obj.lng || obj.Lng;
      delete obj.Lat;
      delete obj.Lng;
    } else {
      return obj;
    }
  },  

  refreshMap: function(){
    this.clearMarkers();
    this.createMap();
  },

  clearMarkers: function(){
    while (this.markers.length) { this.markers.pop().setMap(null); }
  },

  createMap: function() {
    var that = this;
    var tripDays = this.props.plan.groups;
    var coords = !!this.props.plan.Destination ? this.props.plan.Destination.center : tripDays[0].items[0].location;
    var bounds = new google.maps.LatLngBounds();
    var hidePOI =     {
      featureType: "poi",
      stylers: [
        { visibility: "off" }
      ]
    };

    var mapOptions = { zoom: 12, mapTypeControl: false, scrollwheel: false,
                       streetViewControl: false, panControl: false,
                       styles: [ hidePOI ],
                       center: new google.maps.LatLng(coords.lat, coords.lng)};

    this.runningIndex = 0;
    this.map = !!this.map ? this.map : new google.maps.Map(this.refs.map_canvas.getDOMNode(), mapOptions);
    this.bounds = bounds;
    this.placesService = new google.maps.places.PlacesService(this.map);
    this.numPlaces = 0;

    var infowindow = new google.maps.InfoWindow({
      pixelOffset: new google.maps.Size(0,-30)
    });
    
    var batchedGoogleCalls = [],
        batchIndex = 0;


    tripDays.forEach(function(day, dayIndex){
      day.items.forEach(function(item, itemIndex){
        
        if (that.isLatLng(item.location)){
          that.normalizeLatLng(item.location);
          that.createStaticMarker(item, itemIndex, dayIndex, that.runningIndex, infowindow, bounds);
          that.runningIndex++;
        } else {
          if (item.googleplaces_id){
            if (!batchedGoogleCalls[batchIndex]) batchedGoogleCalls[batchIndex] = [];
            var batch = batchedGoogleCalls[batchIndex];

            batch.push({
              item: item, 
              itemIndex: itemIndex, 
              dayIndex: dayIndex, 
              runningIndex: that.runningIndex,
            });

            if (batch.length > 3) batchIndex++;
            that.runningIndex++;
          } else {
            // console.log("can't be mapped", runningIndex) 
          }
        }
      });
    });

    //this.createLazyMarkers(batchedGoogleCalls, infowindow, bounds);
    //if (batchedGoogleCalls.length === 0) this.map.fitBounds(bounds);
  },

  createStaticMarker: function(item, itemIndex, dayIndex, runningIndex, infowindow, bounds){
    var that = this;

    var marker = new RichMarker({
      position: new google.maps.LatLng(item.location.lat, item.location.lng),
      map: that.map,
      title: item.name,
      animation: google.maps.Animation.DROP,
      content: "<span class='marker-pin day_" + (dayIndex+1)  +"'><span>" + (runningIndex+1) + "</span></span>",
      flat: true,
      info: "<a href='" + ("/"+ item.destination +"/attraction/" + item.slug + '/' + item.id) + "'><div class='infowindow-content'><h4>" + item.name + "</h4></div></a>" 
    });

    google.maps.event.addListener(marker, 'click', function() {
      infowindow.setContent(this.info);
      infowindow.open(that.map,this);
    });
    
    this.markers.push(marker);    
    bounds.extend(marker.getPosition());  
  },

  createLazyMarkers: function(batches, infowindow, bounds){
    var index = 0,
        self = this;

    function geolocateBatch(batch, index){
      for (var i=0; i<batch.length; i++){
        var item = batch[i];
        self.createLazyMarker(item.item, item.itemIndex, item.dayIndex, item.runningIndex, infowindow, bounds);
        self.map.fitBounds(bounds);
      }

      index++;
      if (!!batches[index]){
        setTimeout(function(){
          geolocateBatch(batches[index], index);
        }, 2000);
      }
    }

    if (!!batches[0] && batches[0].length > 0) geolocateBatch(batches[0], 0);
  },

  createLazyMarker: function(item, itemIndex, dayIndex, runningIndex, infowindow, bounds){
    var that = this;

    this.placesService.getDetails({ placeId: item.googleplaces_id }, function(place, status){
      if (status === "OK"){
        item.location = {
          lat: place.geometry.location.lat(), 
          lng: place.geometry.location.lng()
        }

        that.createStaticMarker(item, itemIndex, dayIndex, runningIndex, infowindow, bounds)
      } else {
        console.log("Error in geolocating", status)
      }
    });  
  },

  handleScroll: function(e) {
    if (this.props.isSmallScreen || !this.props.mapFor) return; // don't use fixed map style for mobile
    
    var elem = (this.refs.mapContainer) ? $(this.refs.mapContainer.getDOMNode()) : $('.map-column .map-container').first(),
        wrapper = elem.parents(".info-section").first();

    var scrollY = $(window).scrollTop(),
        mapTop = wrapper.offset().top;

    var container = wrapper.find(".agenda-column").first(),
        pageHeader = $("header"),
        sticksTo = container.find(this.props.mapFor),
        lastItem = sticksTo.last(),
        mapContent = $(".map-contents:first");
        
    var mapBottom = lastItem.offset().top + lastItem.height() /* - pageHeader.height() */ - mapContent.height(),
        reachedBottom = scrollY > mapBottom;
    
    var mapWidth = elem.width();
    if (mapWidth < 100){ 
      (mapWidth = wrapper.width() * 0.35) | 0;
    }

    if (!reachedBottom && scrollY >= mapTop /* - pageHeader.height() */) {
      this.setState({
        mapContainerStyle: {
          position: "fixed",
          width: mapWidth,
          top: 0//pageHeader.height()
        }
      })
    } else if (reachedBottom) {
      this.setState({
        mapContainerStyle: {
          position: "absolute",
          width: mapWidth,
          top: parseInt(lastItem[0].offsetTop, 10) + parseInt(lastItem[0].offsetHeight, 10) - parseInt(mapContent[0].offsetHeight, 10)
        }
      })
    } else {
      this.setState({ 
        mapContainerStyle: {
          position: "relative",
          width: "auto",
          top: "auto"
        }
      })
    }
  },

  toggleMap: function(e) {
    e.preventDefault(); 
    var view = this.props.guideState.viewType === "map-view" ? "list-view" : "map-view";
    this.props.guideApi.updateState({ viewType: view })


    var elem = (this.refs.mapContainer) ? $(this.refs.mapContainer.getDOMNode()) : $('.map-column .map-container').first(),
        wrapper = elem.parents(".info-section").first();
    
    var targetWidth = (view === "map-view" ? 0.65 : 0.35);

    this.setState({
      mapContainerStyle: {
        position: this.state.mapContainerStyle.position,
        top: this.state.mapContainerStyle.top,
        width: wrapper.width() * targetWidth
      },
      mapExpanded: !this.state.mapExpanded
    })

    var self = this;
    setTimeout(function(){
      self.redrawMap();
    }, 400)
  },

  redrawMap: function() {
    google.maps.event.trigger( this.map, "resize" );
    this.map.setCenter( this.map.getCenter() );
    this.map.fitBounds( this.bounds );
  },
  
  componentDidUpdate: function(){
    this.redrawMap();
  },

  componentDidMount: function() {

    var that = this;

    if (this.props.isSmallScreen) {
      $('.essential-guide').css('min-height', $(window).height() - $('footer').height() - 54 - 24);
    }
    
    this.createMap();
    this.mapPosition = $(this.refs.mapContainer.getDOMNode()).offset();
    this.mapInitialHeight = $(window).height() - this.mapPosition.top;
    this.setState({
      mapCanvasStyle: {
        //height: this.mapInitialHeight - (this.props.isSmallScreen ? 54 : 40)
      }
    }, function() {
      setTimeout(that.redrawMap, 500);
    });
    
    this.handleScroll();

    $(window).on("filters-changed", this.refreshMap);
    $(window).on("view-changed", this.handleScroll);
    $(window).on("show-map", this.redrawMap);

    window.addEventListener('scroll', this.handleScroll);

    var beforePrint = function(e) {
      console.log("Printing")
      // setTimeout(function(){
        google.maps.event.trigger( this.map, "resize" );
      // }.bind(this), 100);
      console.log("Map Redrawn")
    }.bind(this);
    
    var afterPrint = function(e) {
      console.log("After Print")
      // this.redrawMap();
      console.log("Map Redrawn")
    }.bind(this)

    if (window.matchMedia) {
      var mediaQueryList = window.matchMedia('print');
      mediaQueryList.addListener(function(mql) {
        if (mql.matches) { 
          beforePrint(mql) 
        } else {
          afterPrint(mql)
        }
      });
    }

    window.onbeforeprint = beforePrint;
    window.onaftereprint = afterPrint;
  },
  
  componentWillUnmount: function() {
    $(window).off("filters-changed", this.refreshMap);
    $(window).off("view-changed", this.handleScroll);
    $(window).off("show-map", this.redrawMap);
    
    window.removeEventListener('scroll', this.handleScroll);
  },
  
  render: function() {
    var elem = (this.refs.mapContainer) ? $(this.refs.mapContainer.getDOMNode()) : $('.map-column .map-container').first(),
        wrapper = elem.parents(".info-section").first();

    var mapToggleButton = <a href="#" onClick={this.toggleMap}><i className="fa fa-expand"></i> Expand</a>;
    if (this.state.mapExpanded) {
      mapToggleButton = <a href="#" onClick={this.toggleMap}><i className="fa fa-compress"></i> Collapse</a>;
    }

    if (this.props.isSmallScreen) {
      mapToggleButton = <a href="#" onClick={this.props.onChangeView.bind(null, 'list-view')}><i className="fa fa-arrow-left"></i> Back</a>;
    }
    
    var placeCount = this.props.numPlaces + (this.props.numPlaces > 1 ? ' Places' : ' Place' );        
    
    return (
      <div className="map-container" style={this.state.mapContainerStyle} ref="mapContainer">
        <div className="map-contents">
          <h2 className='map-header'>{mapToggleButton} <span className="place-count">{this.runningIndex} Places</span></h2>
          <div className="plan-map" ref="map_canvas" style={this.state.mapCanvasStyle}></div>
        </div>
      </div>
   );  
  }
});

module.exports = TravelMap;



// WEBPACK FOOTER //
// ./components/map.js